import { z } from 'zod';
/** Estado de un componente observable. `down` implica que el servicio no acepta trabajo. */
export const healthStatusSchema = z.enum(['ok', 'degraded', 'down']);
export const healthCheckSchema = z.object({
    name: z.string().min(1),
    status: healthStatusSchema,
    detail: z.string().optional(),
});
/** `live`: el proceso responde. No comprueba dependencias. */
export const healthLiveResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.string().min(1),
    version: z.string().min(1),
    uptimeSeconds: z.number().nonnegative(),
});
/** `ready`: el proceso puede aceptar trabajo porque sus dependencias responden. */
export const healthReadyResponseSchema = z.object({
    status: healthStatusSchema,
    service: z.string().min(1),
    version: z.string().min(1),
    checks: z.array(healthCheckSchema),
});
/** El peor estado manda: un único `down` deja el servicio no disponible. */
export function aggregateHealthStatus(checks) {
    if (checks.some((check) => check.status === 'down'))
        return 'down';
    if (checks.some((check) => check.status === 'degraded'))
        return 'degraded';
    return 'ok';
}
//# sourceMappingURL=health.js.map